import React, {useContext} from "react";
import styles from "./caseCoverageCard/CaseCoverageCard.module.scss";
import appContext from "../../../../../../context/appContext";
import {useLocation} from "react-router-dom";

const CaseCoverageCard = ({ title, coveredTitle, totalTitle, coveredPercentage, covered, total, show = true, activeFilters = false }) => {

  let sqSize = "61";
  if (activeFilters) {
    sqSize = 90;
  }
  let radius = (sqSize - 10) / 2;
  const viewBox = `0 0 ${sqSize} ${sqSize}`;
  const dashArray = radius * Math.PI * 2;
  const parsedToNumber =  parseFloat(coveredPercentage) || 0;
  const dashOffset = dashArray - dashArray * parsedToNumber / 100;

  const context = useContext(appContext)

  const location = useLocation()

  if (show) {
    return (
      <>
        {
          !activeFilters ?
            <div className={styles.CaseCoverageCard}>
              <div className={styles.title}>
                { title }
              </div>
              <div className={'d-flex align-items-center'}>
                <div className={`${styles.chart} d-flex`}>
                  <svg
                    width={sqSize}
                    height={sqSize}
                    viewBox={viewBox}>
                    <circle
                      className={styles.circleBackground}
                      cx={sqSize / 2}
                      cy={sqSize / 2}
                      r={radius}
                      strokeWidth={`3px`} />
                    <circle
                      className={styles.circleProgress}
                      cx={sqSize / 2}
                      cy={sqSize / 2}
                      r={radius}
                      strokeWidth={`2px`}
                      transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
                      style={{
                        strokeDasharray: dashArray,
                        strokeDashoffset: dashOffset,
                        stroke: location.pathname === "/process-compare" && context?.handleLayerList()?.length && context?.handleLayerList()?.find(item => item.selected)?.color
                      }} />
                    <text
                      className={styles.circleText}
                      x="50%"
                      y="50%"
                      dy=".3em"
                      textAnchor="middle">
                      {coveredPercentage || "0%"}
                    </text>
                  </svg>
                </div>
                <div className={styles.chartData}>
                  <div className={'d-block'}>
                    <div>
                      { covered || 0 }
                    </div>
                    <div>
                      { coveredTitle }
                    </div>
                  </div>
                  <div className={'d-block'}>
                    <div>
                      { total || 0}
                    </div>
                    <div>
                      { totalTitle }
                    </div>
                  </div>
                </div>
              </div>
            </div> :
            <div className={styles.CaseCoverageCardActiveFilters}>
              <div className={styles.CaseCoverageCard}>
                <div>
                  <div className={`${styles.chart} d-flex align-items-center justify-content-center`}>
                    <svg
                      width={sqSize}
                      height={sqSize}
                      viewBox={viewBox}>
                      <circle
                        className={styles.circleBackground}
                        cx={sqSize / 2}
                        cy={sqSize / 2}
                        r={radius}
                        strokeWidth={`3px`} />
                      <circle
                        className={styles.circleProgress}
                        cx={sqSize / 2}
                        cy={sqSize / 2}
                        r={radius}
                        strokeWidth={`8px`}
                        transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
                        style={{
                          strokeDasharray: dashArray,
                          strokeDashoffset: dashOffset,
                          transition: "all 0.3s ease-in"
                        }} />
                      <text
                        className={styles.circleText}
                        x="50%"
                        y="45%"
                        dy=".3em"
                        textAnchor="middle">
                        {coveredPercentage || "0%"}
                      </text>
                      <text
                        className={styles.circleSubtitle}
                        style={{marginTop: 40}}
                        x="50%"
                        y="60%"
                        dy=".3em"
                        textAnchor="middle">
                        {title}
                      </text>
                    </svg>
                  </div>
                  <div className={`${styles.coveredNumber} align-items-center justify-content-center`}>
                    {covered}
                  </div>
                  <div className={`${styles.coveredTitle} align-items-center justify-content-center`}>
                    {coveredTitle}
                  </div>
                </div>
              </div>
            </div>
        }
      </>
    )
  } else {
    return null
  }
}

export default CaseCoverageCard;